import React, { useEffect, useRef } from 'react';
import { Modal, Typography, Tag } from 'antd';
import { AppleOutlined, AndroidOutlined, WindowsOutlined } from '@ant-design/icons';
import { MapContainer, TileLayer, Marker, Popup, Circle, useMap } from 'react-leaflet';
import L from 'leaflet';

const { Title, Text } = Typography;

// Fix Leaflet default icon paths
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
    iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

// Custom component to trigger invalidateSize
const MapFixer = () => {
    const map = useMap();
    useEffect(() => {
        setTimeout(() => {
            map.invalidateSize();
        }, 100); // Delay to let modal fully render
    }, [map]);
    return null;
};

const ModalLocationInfo = ({ visible, onClose, device }) => {
    const locationData = device?.locationStatus;

    return (
        <Modal
            title={
                <Title level={4}>
                    📍 Last reported location
                    {locationData?.updatedAt && (
                        <Text type="secondary" style={{ marginLeft: 8, fontSize: '14px' }}>
                            ({new Date(locationData.updatedAt).toLocaleString()})
                        </Text>
                    )}
                </Title>
            }
            open={visible}
            onCancel={onClose}
            footer={null}
            width={700}
        >
            {!locationData ? (
                <Text type="secondary">No location data available.</Text>
            ) : (
                <>
                    <div
                        style={{
                            marginTop: 20,
                            height: 300,
                            borderRadius: 8,
                            overflow: 'hidden',
                            width: '100%',
                            position: 'relative',
                        }}
                    >
                        <MapContainer
                            center={[locationData.latitude, locationData.longitude]}
                            zoom={16}
                            style={{ height: '100%', width: '100%' }}
                            scrollWheelZoom={false}
                        >
                            <MapFixer />
                            <TileLayer
                                attribution="&copy; OpenStreetMap contributors"
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <Marker position={[locationData.latitude, locationData.longitude]}>
                                <Popup>
                                    {device?.Platform === 'iOS' && <AppleOutlined style={{ marginRight: 6 }} />}
                                    {device?.Platform === 'Android' && <AndroidOutlined style={{ marginRight: 6 }} />}
                                    {device?.Platform === 'Windows' && <WindowsOutlined style={{ marginRight: 6 }} />}
                                    {device?.Name || 'Device'}
                                </Popup>
                            </Marker>
                            {locationData.accuracy && (
                                <Circle
                                    center={[locationData.latitude, locationData.longitude]}
                                    radius={locationData.accuracy}
                                    pathOptions={{ fillColor: '#1890ff', color: '#1677ff', fillOpacity: 0.2 }}
                                />
                            )}
                        </MapContainer>
                    </div>
                    <div style={{ marginTop: 12 }}>
                        <Tag color="blue">Accuracy: {locationData.accuracy?.toFixed(1)} m</Tag>
                    </div>
                </>
            )}
        </Modal>
    );
};

export default ModalLocationInfo;